import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "homepage" */ "./ProductInventory"),{
		fallback: <div>Loading...</div>
	})
};
